export const noTrackingOptions = [
    { label: "Track assistant usage", value: false },
    { label: "Don't track assistant usage", value: true }
];

export const callRecordingOptions = [
    { label: "Call Recording Enabled", value: true },
    { label: "Call Recording Disabled", value: false }
];

export const SpeechCleaningOptions = [
    { label: "Enable speech cleaning", value: false },
    { label: "Disable speech cleaning", value: true }
]

export const virtualNumberOptions = [
    { label: "Use virtual number", value: true },
    { label: "Purchase real phone number", value: false }
];

export const disableBargeInOptions = [
    { label: "Enable barge-in", value: false },
    { label: "Disable barge-in", value: true }
];

export const disableSpamFilterOptions = [
    { label: "Enable spam filter", value: false },
    { label: "Disable spam filter", value: true }
]

export const useGracefulRepromptHangupOptions = [
    { label: "Enabled", value: true },
    { label: "Disabled", value: false }
]

export const disableSpeechStartedOptions = [
    { label: "Enable speech started event", value: false },
    { label: "Disable speech started event", value: true }
];
export const attemptInitialTransferOptions = [
    { label: "Do not try store first", value: false },
    { label: "Try store first", value: true }
];

export const autoTransferPreviouslyTransferredOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false }
];

export const useForOutboundCallingOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false }
];

export const outboundCallingEnabledOptions = [
    { label: "Enabled", value: true },
    { label: "Disabled", value: false }
];

export const generalYesNoOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false }
];

export const tryWebsocketReconnectionOnWelcomeOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false }
];

export const initialTransferWithCallingNumberOptions = [
    { label: "Transfer with assistant number", value: false },
    { label: "Transfer with caller's number", value: true }
];

export const useProactiveOptions = [
    { label: "Enable proactive responses", value: true },
    { label: "Disable proactive responses", value: false }
];
export const useGenerativeProactiveOptions = [
    { label: "Enable generative proactive responses", value: true },
    { label: "Disable generative proactive responses", value: false }
];


export const disableWelcomeMessageBargeInOptions = [
    { label: "Allow barge in during welcome message", value: false },
    { label: "Disallow barge in during welcome message", value: true }
];

export const mergeTurnsAfterPausesOptions = [
    { label: "Merge turns after pauses", value: true },
    { label: "Don't merge turns after pauses", value: false }
];

export type GoogleTTSVoice = "Custom" | "af-ZA-Standard-A" | "ar-XA-Standard-A" | "ar-XA-Standard-B" | "ar-XA-Standard-C" | "ar-XA-Standard-D" | "ar-XA-Wavenet-A" | "ar-XA-Wavenet-B" | "ar-XA-Wavenet-C" | "ar-XA-Wavenet-D" | "bn-IN-Standard-A" | "bn-IN-Standard-B" | "bn-IN-Wavenet-A" | "bn-IN-Wavenet-B" | "bg-bg-Standard-A" | "ca-es-Standard-A" | "yue-HK-Standard-A" | "yue-HK-Standard-B" | "yue-HK-Standard-C" | "yue-HK-Standard-D" | "cs-CZ-Standard-A" | "cs-CZ-Wavenet-A" | "da-DK-Standard-A" | "da-DK-Standard-C" | "da-DK-Standard-D" | "da-DK-Standard-E" | "da-DK-Wavenet-A" | "da-DK-Wavenet-C" | "da-DK-Wavenet-D" | "da-DK-Wavenet-E" | "nl-BE-Standard-A" | "nl-BE-Standard-B" | "nl-BE-Wavenet-A" | "nl-BE-Wavenet-B" | "nl-NL-Standard-A" | "nl-NL-Standard-B" | "nl-NL-Standard-C" | "nl-NL-Standard-D" | "nl-NL-Standard-E" | "nl-NL-Wavenet-A" | "nl-NL-Wavenet-B" | "nl-NL-Wavenet-C" | "nl-NL-Wavenet-D" | "nl-NL-Wavenet-E" | "en-AU-Neural2-A" | "en-AU-Standard-A" | "en-AU-Standard-B" | "en-AU-Standard-C" | "en-AU-Standard-D" | "en-AU-Wavenet-A" | "en-AU-Wavenet-B" | "en-AU-Wavenet-C" | "en-AU-Wavenet-D" | "en-IN-Standard-A" | "en-IN-Standard-B" | "en-IN-Standard-C" | "en-IN-Standard-D" | "en-IN-Wavenet-A" | "en-IN-Wavenet-B" | "en-IN-Wavenet-C" | "en-IN-Wavenet-D" | "en-GB-Neural2-A" | "en-GB-Standard-A" | "en-GB-Standard-B" | "en-GB-Standard-C" | "en-GB-Standard-D" | "en-GB-Standard-F" | "en-GB-Wavenet-A" | "en-GB-Wavenet-B" | "en-GB-Wavenet-C" | "en-GB-Wavenet-D" | "en-GB-Wavenet-F" | "en-US-Neural2-A" | "en-US-Neural2-C" | "en-US-Neural2-D" | "en-US-Neural2-E" | "en-US-Neural2-F" | "en-US-Neural2-G" | "en-US-Neural2-H" | "en-US-Neural2-I" | "en-US-Neural2-J" | "en-US-Standard-A" | "en-US-Standard-B" | "en-US-Standard-C" | "en-US-Standard-D" | "en-US-Standard-E" | "en-US-Standard-F" | "en-US-Standard-G" | "en-US-Standard-H" | "en-US-Standard-I" | "en-US-Standard-J" | "en-US-Wavenet-A" | "en-US-Wavenet-B" | "en-US-Wavenet-C" | "en-US-Wavenet-D" | "en-US-Wavenet-E" | "en-US-Wavenet-F" | "en-US-Wavenet-G" | "en-US-Wavenet-H" | "en-US-Wavenet-I" | "en-US-Wavenet-J" | "fil-PH-Standard-A" | "fil-PH-Standard-B" | "fil-PH-Standard-C" | "fil-PH-Standard-D" | "fil-PH-Wavenet-A" | "fil-PH-Wavenet-B" | "fil-PH-Wavenet-C" | "fil-PH-Wavenet-D" | "fi-FI-Standard-A" | "fi-FI-Wavenet-A" | "fr-CA-Standard-A" | "fr-CA-Standard-B" | "fr-CA-Standard-C" | "fr-CA-Standard-D" | "fr-CA-Wavenet-A" | "fr-CA-Wavenet-B" | "fr-CA-Wavenet-C" | "fr-CA-Wavenet-D" | "fr-FR-Standard-A" | "fr-FR-Standard-B" | "fr-FR-Standard-C" | "fr-FR-Standard-D" | "fr-FR-Standard-E" | "fr-FR-Wavenet-A" | "fr-FR-Wavenet-B" | "fr-FR-Wavenet-C" | "fr-FR-Wavenet-D" | "fr-FR-Wavenet-E" | "de-DE-Standard-A" | "de-DE-Standard-B" | "de-DE-Standard-C" | "de-DE-Standard-D" | "de-DE-Standard-E" | "de-DE-Standard-F" | "de-DE-Wavenet-A" | "de-DE-Wavenet-B" | "de-DE-Wavenet-C" | "de-DE-Wavenet-D" | "de-DE-Wavenet-E" | "de-DE-Wavenet-F" | "el-GR-Standard-A" | "el-GR-Wavenet-A" | "gu-IN-Standard-A" | "gu-IN-Standard-B" | "gu-IN-Wavenet-A" | "gu-IN-Wavenet-B" | "hi-IN-Standard-A" | "hi-IN-Standard-B" | "hi-IN-Standard-C" | "hi-IN-Standard-D" | "hi-IN-Wavenet-A" | "hi-IN-Wavenet-B" | "hi-IN-Wavenet-C" | "hi-IN-Wavenet-D" | "hu-HU-Standard-A" | "hu-HU-Wavenet-A" | "is-is-Standard-A" | "id-ID-Standard-A" | "id-ID-Standard-B" | "id-ID-Standard-C" | "id-ID-Standard-D" | "id-ID-Wavenet-A" | "id-ID-Wavenet-B" | "id-ID-Wavenet-C" | "id-ID-Wavenet-D" | "it-IT-Standard-A" | "it-IT-Standard-B" | "it-IT-Standard-C" | "it-IT-Standard-D" | "it-IT-Wavenet-A" | "it-IT-Wavenet-B" | "it-IT-Wavenet-C" | "it-IT-Wavenet-D" | "ja-JP-Standard-A" | "ja-JP-Standard-B" | "ja-JP-Standard-C" | "ja-JP-Standard-D" | "ja-JP-Wavenet-A" | "ja-JP-Wavenet-B" | "ja-JP-Wavenet-C" | "ja-JP-Wavenet-D" | "kn-IN-Standard-A" | "kn-IN-Standard-B" | "kn-IN-Wavenet-A" | "kn-IN-Wavenet-B" | "ko-KR-Standard-A" | "ko-KR-Standard-B" | "ko-KR-Standard-C" | "ko-KR-Standard-D" | "ko-KR-Wavenet-A" | "ko-KR-Wavenet-B" | "ko-KR-Wavenet-C" | "ko-KR-Wavenet-D" | "lv-lv-Standard-A" | "ms-MY-Standard-A" | "ms-MY-Standard-B" | "ms-MY-Standard-C" | "ms-MY-Standard-D" | "ms-MY-Wavenet-A" | "ms-MY-Wavenet-B" | "ms-MY-Wavenet-C" | "ms-MY-Wavenet-D" | "ml-IN-Standard-A" | "ml-IN-Standard-B" | "ml-IN-Wavenet-A" | "ml-IN-Wavenet-B" | "cmn-CN-Standard-A" | "cmn-CN-Standard-B" | "cmn-CN-Standard-C" | "cmn-CN-Standard-D" | "cmn-CN-Wavenet-A" | "cmn-CN-Wavenet-B" | "cmn-CN-Wavenet-C" | "cmn-CN-Wavenet-D" | "cmn-TW-Standard-A" | "cmn-TW-Standard-B" | "cmn-TW-Standard-C" | "cmn-TW-Wavenet-A" | "cmn-TW-Wavenet-B" | "cmn-TW-Wavenet-C" | "nb-NO-Standard-A" | "nb-NO-Standard-B" | "nb-NO-Standard-C" | "nb-NO-Standard-D" | "nb-NO-Wavenet-A" | "nb-NO-Wavenet-B" | "nb-NO-Wavenet-C" | "nb-NO-Wavenet-D" | "nb-no-Standard-E" | "nb-no-Wavenet-E" | "pl-PL-Standard-A" | "pl-PL-Standard-B" | "pl-PL-Standard-C" | "pl-PL-Standard-D" | "pl-PL-Standard-E" | "pl-PL-Wavenet-A" | "pl-PL-Wavenet-B" | "pl-PL-Wavenet-C" | "pl-PL-Wavenet-D" | "pl-PL-Wavenet-E" | "pt-BR-Standard-A" | "pt-BR-Standard-B" | "pt-BR-Wavenet-A" | "pt-BR-Wavenet-B" | "pt-PT-Standard-A" | "pt-PT-Standard-B" | "pt-PT-Standard-C" | "pt-PT-Standard-D" | "pt-PT-Wavenet-A" | "pt-PT-Wavenet-B" | "pt-PT-Wavenet-C" | "pt-PT-Wavenet-D" | "pa-IN-Standard-A" | "pa-IN-Standard-B" | "pa-IN-Standard-C" | "pa-IN-Standard-D" | "pa-IN-Wavenet-A" | "pa-IN-Wavenet-B" | "pa-IN-Wavenet-C" | "pa-IN-Wavenet-D" | "ro-RO-Standard-A" | "ro-RO-Wavenet-A" | "ru-RU-Standard-A" | "ru-RU-Standard-B" | "ru-RU-Standard-C" | "ru-RU-Standard-D" | "ru-RU-Standard-E" | "ru-RU-Wavenet-A" | "ru-RU-Wavenet-B" | "ru-RU-Wavenet-C" | "ru-RU-Wavenet-D" | "ru-RU-Wavenet-E" | "sr-rs-Standard-A" | "sk-SK-Standard-A" | "sk-SK-Wavenet-A" | "es-ES-Standard-A" | "es-ES-Standard-B" | "es-ES-Standard-C" | "es-ES-Standard-D" | "es-ES-Wavenet-B" | "es-ES-Wavenet-C" | "es-ES-Wavenet-D" | "es-US-Neural2-A" | "es-US-Standard-A" | "es-US-Standard-B" | "es-US-Standard-C" | "es-US-Wavenet-A" | "es-US-Wavenet-B" | "es-US-Wavenet-C" | "sv-SE-Standard-A" | "sv-SE-Standard-B" | "sv-SE-Standard-C" | "sv-SE-Standard-D" | "sv-SE-Standard-E" | "sv-SE-Wavenet-A" | "sv-SE-Wavenet-B" | "sv-SE-Wavenet-C" | "sv-SE-Wavenet-D" | "sv-SE-Wavenet-E" | "ta-IN-Standard-A" | "ta-IN-Standard-B" | "ta-IN-Wavenet-A" | "ta-IN-Wavenet-B" | "te-IN-Standard-A" | "te-IN-Standard-B" | "th-TH-Standard-A" | "tr-TR-Standard-A" | "tr-TR-Standard-B" | "tr-TR-Standard-C" | "tr-TR-Standard-D" | "tr-TR-Standard-E" | "tr-TR-Wavenet-A" | "tr-TR-Wavenet-B" | "tr-TR-Wavenet-C" | "tr-TR-Wavenet-D" | "tr-TR-Wavenet-E" | "uk-UA-Standard-A" | "uk-UA-Wavenet-A" | "vi-VN-Standard-A" | "vi-VN-Standard-B" | "vi-VN-Standard-C" | "vi-VN-Standard-D" | "vi-VN-Wavenet-A" | "vi-VN-Wavenet-B" | "vi-VN-Wavenet-C" | "vi-VN-Wavenet-D"

export const googleVoiceOptions = [
    { value: "Custom", label: "Custom" },
    { value: "af-ZA-Standard-A", label: "af-ZA-Standard-A" },
    { value: "ar-XA-Standard-A", label: "ar-XA-Standard-A" },
    { value: "ar-XA-Standard-B", label: "ar-XA-Standard-B" },
    { value: "ar-XA-Standard-C", label: "ar-XA-Standard-C" },
    { value: "ar-XA-Standard-D", label: "ar-XA-Standard-D" },
    { value: "ar-XA-Wavenet-A", label: "ar-XA-Wavenet-A" },
    { value: "ar-XA-Wavenet-B", label: "ar-XA-Wavenet-B" },
    { value: "ar-XA-Wavenet-C", label: "ar-XA-Wavenet-C" },
    { value: "ar-XA-Wavenet-D", label: "ar-XA-Wavenet-D" },
    { value: "bn-IN-Standard-A", label: "bn-IN-Standard-A" },
    { value: "bn-IN-Standard-B", label: "bn-IN-Standard-B" },
    { value: "bn-IN-Wavenet-A", label: "bn-IN-Wavenet-A" },
    { value: "bn-IN-Wavenet-B", label: "bn-IN-Wavenet-B" },
    { value: "bg-bg-Standard-A", label: "bg-bg-Standard-A" },
    { value: "ca-es-Standard-A", label: "ca-es-Standard-A" },
    { value: "yue-HK-Standard-A", label: "yue-HK-Standard-A" },
    { value: "yue-HK-Standard-B", label: "yue-HK-Standard-B" },
    { value: "yue-HK-Standard-C", label: "yue-HK-Standard-C" },
    { value: "yue-HK-Standard-D", label: "yue-HK-Standard-D" },
    { value: "cs-CZ-Standard-A", label: "cs-CZ-Standard-A" },
    { value: "cs-CZ-Wavenet-A", label: "cs-CZ-Wavenet-A" },
    { value: "da-DK-Standard-A", label: "da-DK-Standard-A" },
    { value: "da-DK-Standard-C", label: "da-DK-Standard-C" },
    { value: "da-DK-Standard-D", label: "da-DK-Standard-D" },
    { value: "da-DK-Standard-E", label: "da-DK-Standard-E" },
    { value: "da-DK-Wavenet-A", label: "da-DK-Wavenet-A" },
    { value: "da-DK-Wavenet-C", label: "da-DK-Wavenet-C" },
    { value: "da-DK-Wavenet-D", label: "da-DK-Wavenet-D" },
    { value: "da-DK-Wavenet-E", label: "da-DK-Wavenet-E" },
    { value: "nl-BE-Standard-A", label: "nl-BE-Standard-A" },
    { value: "nl-BE-Standard-B", label: "nl-BE-Standard-B" },
    { value: "nl-BE-Wavenet-A", label: "nl-BE-Wavenet-A" },
    { value: "nl-BE-Wavenet-B", label: "nl-BE-Wavenet-B" },
    { value: "nl-NL-Standard-A", label: "nl-NL-Standard-A" },
    { value: "nl-NL-Standard-B", label: "nl-NL-Standard-B" },
    { value: "nl-NL-Standard-C", label: "nl-NL-Standard-C" },
    { value: "nl-NL-Standard-D", label: "nl-NL-Standard-D" },
    { value: "nl-NL-Standard-E", label: "nl-NL-Standard-E" },
    { value: "nl-NL-Wavenet-A", label: "nl-NL-Wavenet-A" },
    { value: "nl-NL-Wavenet-B", label: "nl-NL-Wavenet-B" },
    { value: "nl-NL-Wavenet-C", label: "nl-NL-Wavenet-C" },
    { value: "nl-NL-Wavenet-D", label: "nl-NL-Wavenet-D" },
    { value: "nl-NL-Wavenet-E", label: "nl-NL-Wavenet-E" },
    { value: "en-AU-Neural2-A", label: "en-AU-Neural2-A" },
    { value: "en-AU-Standard-A", label: "en-AU-Standard-A" },
    { value: "en-AU-Standard-B", label: "en-AU-Standard-B" },
    { value: "en-AU-Standard-C", label: "en-AU-Standard-C" },
    { value: "en-AU-Standard-D", label: "en-AU-Standard-D" },
    { value: "en-AU-Wavenet-A", label: "en-AU-Wavenet-A" },
    { value: "en-AU-Wavenet-B", label: "en-AU-Wavenet-B" },
    { value: "en-AU-Wavenet-C", label: "en-AU-Wavenet-C" },
    { value: "en-AU-Wavenet-D", label: "en-AU-Wavenet-D" },
    { value: "en-IN-Standard-A", label: "en-IN-Standard-A" },
    { value: "en-IN-Standard-B", label: "en-IN-Standard-B" },
    { value: "en-IN-Standard-C", label: "en-IN-Standard-C" },
    { value: "en-IN-Standard-D", label: "en-IN-Standard-D" },
    { value: "en-IN-Wavenet-A", label: "en-IN-Wavenet-A" },
    { value: "en-IN-Wavenet-B", label: "en-IN-Wavenet-B" },
    { value: "en-IN-Wavenet-C", label: "en-IN-Wavenet-C" },
    { value: "en-IN-Wavenet-D", label: "en-IN-Wavenet-D" },
    { value: "en-GB-Neural2-A", label: "en-GB-Neural2-A" },
    { value: "en-GB-Standard-A", label: "en-GB-Standard-A" },
    { value: "en-GB-Standard-B", label: "en-GB-Standard-B" },
    { value: "en-GB-Standard-C", label: "en-GB-Standard-C" },
    { value: "en-GB-Standard-D", label: "en-GB-Standard-D" },
    { value: "en-GB-Standard-F", label: "en-GB-Standard-F" },
    { value: "en-GB-Wavenet-A", label: "en-GB-Wavenet-A" },
    { value: "en-GB-Wavenet-B", label: "en-GB-Wavenet-B" },
    { value: "en-GB-Wavenet-C", label: "en-GB-Wavenet-C" },
    { value: "en-GB-Wavenet-D", label: "en-GB-Wavenet-D" },
    { value: "en-GB-Wavenet-F", label: "en-GB-Wavenet-F" },
    { value: "en-US-Neural2-A", label: "en-US-Neural2-A" },
    { value: "en-US-Neural2-C", label: "en-US-Neural2-C" },
    { value: "en-US-Neural2-D", label: "en-US-Neural2-D" },
    { value: "en-US-Neural2-E", label: "en-US-Neural2-E" },
    { value: "en-US-Neural2-F", label: "en-US-Neural2-F" },
    { value: "en-US-Neural2-G", label: "en-US-Neural2-G" },
    { value: "en-US-Neural2-H", label: "en-US-Neural2-H" },
    { value: "en-US-Neural2-I", label: "en-US-Neural2-I" },
    { value: "en-US-Neural2-J", label: "en-US-Neural2-J" },
    { value: "en-US-Standard-A", label: "en-US-Standard-A" },
    { value: "en-US-Standard-B", label: "en-US-Standard-B" },
    { value: "en-US-Standard-C", label: "en-US-Standard-C" },
    { value: "en-US-Standard-D", label: "en-US-Standard-D" },
    { value: "en-US-Standard-E", label: "en-US-Standard-E" },
    { value: "en-US-Standard-F", label: "en-US-Standard-F" },
    { value: "en-US-Standard-G", label: "en-US-Standard-G" },
    { value: "en-US-Standard-H", label: "en-US-Standard-H" },
    { value: "en-US-Standard-I", label: "en-US-Standard-I" },
    { value: "en-US-Standard-J", label: "en-US-Standard-J" },
    { value: "en-US-Wavenet-A", label: "en-US-Wavenet-A" },
    { value: "en-US-Wavenet-B", label: "en-US-Wavenet-B" },
    { value: "en-US-Wavenet-C", label: "en-US-Wavenet-C" },
    { value: "en-US-Wavenet-D", label: "en-US-Wavenet-D" },
    { value: "en-US-Wavenet-E", label: "en-US-Wavenet-E" },
    { value: "en-US-Wavenet-F", label: "en-US-Wavenet-F" },
    { value: "en-US-Wavenet-G", label: "en-US-Wavenet-G" },
    { value: "en-US-Wavenet-H", label: "en-US-Wavenet-H" },
    { value: "en-US-Wavenet-I", label: "en-US-Wavenet-I" },
    { value: "en-US-Wavenet-J", label: "en-US-Wavenet-J" },
    { value: "fil-PH-Standard-A", label: "fil-PH-Standard-A" },
    { value: "fil-PH-Standard-B", label: "fil-PH-Standard-B" },
    { value: "fil-PH-Standard-C", label: "fil-PH-Standard-C" },
    { value: "fil-PH-Standard-D", label: "fil-PH-Standard-D" },
    { value: "fil-PH-Wavenet-A", label: "fil-PH-Wavenet-A" },
    { value: "fil-PH-Wavenet-B", label: "fil-PH-Wavenet-B" },
    { value: "fil-PH-Wavenet-C", label: "fil-PH-Wavenet-C" },
    { value: "fil-PH-Wavenet-D", label: "fil-PH-Wavenet-D" },
    { value: "fi-FI-Standard-A", label: "fi-FI-Standard-A" },
    { value: "fi-FI-Wavenet-A", label: "fi-FI-Wavenet-A" },
    { value: "fr-CA-Standard-A", label: "fr-CA-Standard-A" },
    { value: "fr-CA-Standard-B", label: "fr-CA-Standard-B" },
    { value: "fr-CA-Standard-C", label: "fr-CA-Standard-C" },
    { value: "fr-CA-Standard-D", label: "fr-CA-Standard-D" },
    { value: "fr-CA-Wavenet-A", label: "fr-CA-Wavenet-A" },
    { value: "fr-CA-Wavenet-B", label: "fr-CA-Wavenet-B" },
    { value: "fr-CA-Wavenet-C", label: "fr-CA-Wavenet-C" },
    { value: "fr-CA-Wavenet-D", label: "fr-CA-Wavenet-D" },
    { value: "fr-FR-Standard-A", label: "fr-FR-Standard-A" },
    { value: "fr-FR-Standard-B", label: "fr-FR-Standard-B" },
    { value: "fr-FR-Standard-C", label: "fr-FR-Standard-C" },
    { value: "fr-FR-Standard-D", label: "fr-FR-Standard-D" },
    { value: "fr-FR-Standard-E", label: "fr-FR-Standard-E" },
    { value: "fr-FR-Wavenet-A", label: "fr-FR-Wavenet-A" },
    { value: "fr-FR-Wavenet-B", label: "fr-FR-Wavenet-B" },
    { value: "fr-FR-Wavenet-C", label: "fr-FR-Wavenet-C" },
    { value: "fr-FR-Wavenet-D", label: "fr-FR-Wavenet-D" },
    { value: "fr-FR-Wavenet-E", label: "fr-FR-Wavenet-E" },
    { value: "de-DE-Standard-A", label: "de-DE-Standard-A" },
    { value: "de-DE-Standard-B", label: "de-DE-Standard-B" },
    { value: "de-DE-Standard-C", label: "de-DE-Standard-C" },
    { value: "de-DE-Standard-D", label: "de-DE-Standard-D" },
    { value: "de-DE-Standard-E", label: "de-DE-Standard-E" },
    { value: "de-DE-Standard-F", label: "de-DE-Standard-F" },
    { value: "de-DE-Wavenet-A", label: "de-DE-Wavenet-A" },
    { value: "de-DE-Wavenet-B", label: "de-DE-Wavenet-B" },
    { value: "de-DE-Wavenet-C", label: "de-DE-Wavenet-C" },
    { value: "de-DE-Wavenet-D", label: "de-DE-Wavenet-D" },
    { value: "de-DE-Wavenet-E", label: "de-DE-Wavenet-E" },
    { value: "de-DE-Wavenet-F", label: "de-DE-Wavenet-F" },
    { value: "el-GR-Standard-A", label: "el-GR-Standard-A" },
    { value: "el-GR-Wavenet-A", label: "el-GR-Wavenet-A" },
    { value: "gu-IN-Standard-A", label: "gu-IN-Standard-A" },
    { value: "gu-IN-Standard-B", label: "gu-IN-Standard-B" },
    { value: "gu-IN-Wavenet-A", label: "gu-IN-Wavenet-A" },
    { value: "gu-IN-Wavenet-B", label: "gu-IN-Wavenet-B" },
    { value: "hi-IN-Standard-A", label: "hi-IN-Standard-A" },
    { value: "hi-IN-Standard-B", label: "hi-IN-Standard-B" },
    { value: "hi-IN-Standard-C", label: "hi-IN-Standard-C" },
    { value: "hi-IN-Standard-D", label: "hi-IN-Standard-D" },
    { value: "hi-IN-Wavenet-A", label: "hi-IN-Wavenet-A" },
    { value: "hi-IN-Wavenet-B", label: "hi-IN-Wavenet-B" },
    { value: "hi-IN-Wavenet-C", label: "hi-IN-Wavenet-C" },
    { value: "hi-IN-Wavenet-D", label: "hi-IN-Wavenet-D" },
    { value: "hu-HU-Standard-A", label: "hu-HU-Standard-A" },
    { value: "hu-HU-Wavenet-A", label: "hu-HU-Wavenet-A" },
    { value: "is-is-Standard-A", label: "is-is-Standard-A" },
    { value: "id-ID-Standard-A", label: "id-ID-Standard-A" },
    { value: "id-ID-Standard-B", label: "id-ID-Standard-B" },
    { value: "id-ID-Standard-C", label: "id-ID-Standard-C" },
    { value: "id-ID-Standard-D", label: "id-ID-Standard-D" },
    { value: "id-ID-Wavenet-A", label: "id-ID-Wavenet-A" },
    { value: "id-ID-Wavenet-B", label: "id-ID-Wavenet-B" },
    { value: "id-ID-Wavenet-C", label: "id-ID-Wavenet-C" },
    { value: "id-ID-Wavenet-D", label: "id-ID-Wavenet-D" },
    { value: "it-IT-Standard-A", label: "it-IT-Standard-A" },
    { value: "it-IT-Standard-B", label: "it-IT-Standard-B" },
    { value: "it-IT-Standard-C", label: "it-IT-Standard-C" },
    { value: "it-IT-Standard-D", label: "it-IT-Standard-D" },
    { value: "it-IT-Wavenet-A", label: "it-IT-Wavenet-A" },
    { value: "it-IT-Wavenet-B", label: "it-IT-Wavenet-B" },
    { value: "it-IT-Wavenet-C", label: "it-IT-Wavenet-C" },
    { value: "it-IT-Wavenet-D", label: "it-IT-Wavenet-D" },
    { value: "ja-JP-Standard-A", label: "ja-JP-Standard-A" },
    { value: "ja-JP-Standard-B", label: "ja-JP-Standard-B" },
    { value: "ja-JP-Standard-C", label: "ja-JP-Standard-C" },
    { value: "ja-JP-Standard-D", label: "ja-JP-Standard-D" },
    { value: "ja-JP-Wavenet-A", label: "ja-JP-Wavenet-A" },
    { value: "ja-JP-Wavenet-B", label: "ja-JP-Wavenet-B" },
    { value: "ja-JP-Wavenet-C", label: "ja-JP-Wavenet-C" },
    { value: "ja-JP-Wavenet-D", label: "ja-JP-Wavenet-D" },
    { value: "kn-IN-Standard-A", label: "kn-IN-Standard-A" },
    { value: "kn-IN-Standard-B", label: "kn-IN-Standard-B" },
    { value: "kn-IN-Wavenet-A", label: "kn-IN-Wavenet-A" },
    { value: "kn-IN-Wavenet-B", label: "kn-IN-Wavenet-B" },
    { value: "ko-KR-Standard-A", label: "ko-KR-Standard-A" },
    { value: "ko-KR-Standard-B", label: "ko-KR-Standard-B" },
    { value: "ko-KR-Standard-C", label: "ko-KR-Standard-C" },
    { value: "ko-KR-Standard-D", label: "ko-KR-Standard-D" },
    { value: "ko-KR-Wavenet-A", label: "ko-KR-Wavenet-A" },
    { value: "ko-KR-Wavenet-B", label: "ko-KR-Wavenet-B" },
    { value: "ko-KR-Wavenet-C", label: "ko-KR-Wavenet-C" },
    { value: "ko-KR-Wavenet-D", label: "ko-KR-Wavenet-D" },
    { value: "lv-lv-Standard-A", label: "lv-lv-Standard-A" },
    { value: "ms-MY-Standard-A", label: "ms-MY-Standard-A" },
    { value: "ms-MY-Standard-B", label: "ms-MY-Standard-B" },
    { value: "ms-MY-Standard-C", label: "ms-MY-Standard-C" },
    { value: "ms-MY-Standard-D", label: "ms-MY-Standard-D" },
    { value: "ms-MY-Wavenet-A", label: "ms-MY-Wavenet-A" },
    { value: "ms-MY-Wavenet-B", label: "ms-MY-Wavenet-B" },
    { value: "ms-MY-Wavenet-C", label: "ms-MY-Wavenet-C" },
    { value: "ms-MY-Wavenet-D", label: "ms-MY-Wavenet-D" },
    { value: "ml-IN-Standard-A", label: "ml-IN-Standard-A" },
    { value: "ml-IN-Standard-B", label: "ml-IN-Standard-B" },
    { value: "ml-IN-Wavenet-A", label: "ml-IN-Wavenet-A" },
    { value: "ml-IN-Wavenet-B", label: "ml-IN-Wavenet-B" },
    { value: "cmn-CN-Standard-A", label: "cmn-CN-Standard-A" },
    { value: "cmn-CN-Standard-B", label: "cmn-CN-Standard-B" },
    { value: "cmn-CN-Standard-C", label: "cmn-CN-Standard-C" },
    { value: "cmn-CN-Standard-D", label: "cmn-CN-Standard-D" },
    { value: "cmn-CN-Wavenet-A", label: "cmn-CN-Wavenet-A" },
    { value: "cmn-CN-Wavenet-B", label: "cmn-CN-Wavenet-B" },
    { value: "cmn-CN-Wavenet-C", label: "cmn-CN-Wavenet-C" },
    { value: "cmn-CN-Wavenet-D", label: "cmn-CN-Wavenet-D" },
    { value: "cmn-TW-Standard-A", label: "cmn-TW-Standard-A" },
    { value: "cmn-TW-Standard-B", label: "cmn-TW-Standard-B" },
    { value: "cmn-TW-Standard-C", label: "cmn-TW-Standard-C" },
    { value: "cmn-TW-Wavenet-A", label: "cmn-TW-Wavenet-A" },
    { value: "cmn-TW-Wavenet-B", label: "cmn-TW-Wavenet-B" },
    { value: "cmn-TW-Wavenet-C", label: "cmn-TW-Wavenet-C" },
    { value: "nb-NO-Standard-A", label: "nb-NO-Standard-A" },
    { value: "nb-NO-Standard-B", label: "nb-NO-Standard-B" },
    { value: "nb-NO-Standard-C", label: "nb-NO-Standard-C" },
    { value: "nb-NO-Standard-D", label: "nb-NO-Standard-D" },
    { value: "nb-NO-Wavenet-A", label: "nb-NO-Wavenet-A" },
    { value: "nb-NO-Wavenet-B", label: "nb-NO-Wavenet-B" },
    { value: "nb-NO-Wavenet-C", label: "nb-NO-Wavenet-C" },
    { value: "nb-NO-Wavenet-D", label: "nb-NO-Wavenet-D" },
    { value: "nb-no-Standard-E", label: "nb-no-Standard-E" },
    { value: "nb-no-Wavenet-E", label: "nb-no-Wavenet-E" },
    { value: "pl-PL-Standard-A", label: "pl-PL-Standard-A" },
    { value: "pl-PL-Standard-B", label: "pl-PL-Standard-B" },
    { value: "pl-PL-Standard-C", label: "pl-PL-Standard-C" },
    { value: "pl-PL-Standard-D", label: "pl-PL-Standard-D" },
    { value: "pl-PL-Standard-E", label: "pl-PL-Standard-E" },
    { value: "pl-PL-Wavenet-A", label: "pl-PL-Wavenet-A" },
    { value: "pl-PL-Wavenet-B", label: "pl-PL-Wavenet-B" },
    { value: "pl-PL-Wavenet-C", label: "pl-PL-Wavenet-C" },
    { value: "pl-PL-Wavenet-D", label: "pl-PL-Wavenet-D" },
    { value: "pl-PL-Wavenet-E", label: "pl-PL-Wavenet-E" },
    { value: "pt-BR-Standard-A", label: "pt-BR-Standard-A" },
    { value: "pt-BR-Standard-B", label: "pt-BR-Standard-B" },
    { value: "pt-BR-Wavenet-A", label: "pt-BR-Wavenet-A" },
    { value: "pt-BR-Wavenet-B", label: "pt-BR-Wavenet-B" },
    { value: "pt-PT-Standard-A", label: "pt-PT-Standard-A" },
    { value: "pt-PT-Standard-B", label: "pt-PT-Standard-B" },
    { value: "pt-PT-Standard-C", label: "pt-PT-Standard-C" },
    { value: "pt-PT-Standard-D", label: "pt-PT-Standard-D" },
    { value: "pt-PT-Wavenet-A", label: "pt-PT-Wavenet-A" },
    { value: "pt-PT-Wavenet-B", label: "pt-PT-Wavenet-B" },
    { value: "pt-PT-Wavenet-C", label: "pt-PT-Wavenet-C" },
    { value: "pt-PT-Wavenet-D", label: "pt-PT-Wavenet-D" },
    { value: "pa-IN-Standard-A", label: "pa-IN-Standard-A" },
    { value: "pa-IN-Standard-B", label: "pa-IN-Standard-B" },
    { value: "pa-IN-Standard-C", label: "pa-IN-Standard-C" },
    { value: "pa-IN-Standard-D", label: "pa-IN-Standard-D" },
    { value: "pa-IN-Wavenet-A", label: "pa-IN-Wavenet-A" },
    { value: "pa-IN-Wavenet-B", label: "pa-IN-Wavenet-B" },
    { value: "pa-IN-Wavenet-C", label: "pa-IN-Wavenet-C" },
    { value: "pa-IN-Wavenet-D", label: "pa-IN-Wavenet-D" },
    { value: "ro-RO-Standard-A", label: "ro-RO-Standard-A" },
    { value: "ro-RO-Wavenet-A", label: "ro-RO-Wavenet-A" },
    { value: "ru-RU-Standard-A", label: "ru-RU-Standard-A" },
    { value: "ru-RU-Standard-B", label: "ru-RU-Standard-B" },
    { value: "ru-RU-Standard-C", label: "ru-RU-Standard-C" },
    { value: "ru-RU-Standard-D", label: "ru-RU-Standard-D" },
    { value: "ru-RU-Standard-E", label: "ru-RU-Standard-E" },
    { value: "ru-RU-Wavenet-A", label: "ru-RU-Wavenet-A" },
    { value: "ru-RU-Wavenet-B", label: "ru-RU-Wavenet-B" },
    { value: "ru-RU-Wavenet-C", label: "ru-RU-Wavenet-C" },
    { value: "ru-RU-Wavenet-D", label: "ru-RU-Wavenet-D" },
    { value: "ru-RU-Wavenet-E", label: "ru-RU-Wavenet-E" },
    { value: "sr-rs-Standard-A", label: "sr-rs-Standard-A" },
    { value: "sk-SK-Standard-A", label: "sk-SK-Standard-A" },
    { value: "sk-SK-Wavenet-A", label: "sk-SK-Wavenet-A" },
    { value: "es-ES-Standard-A", label: "es-ES-Standard-A" },
    { value: "es-ES-Standard-B", label: "es-ES-Standard-B" },
    { value: "es-ES-Standard-C", label: "es-ES-Standard-C" },
    { value: "es-ES-Standard-D", label: "es-ES-Standard-D" },
    { value: "es-ES-Wavenet-B", label: "es-ES-Wavenet-B" },
    { value: "es-ES-Wavenet-C", label: "es-ES-Wavenet-C" },
    { value: "es-ES-Wavenet-D", label: "es-ES-Wavenet-D" },
    { value: "es-US-Neural2-A", label: "es-US-Neural2-A" },
    { value: "es-US-Standard-A", label: "es-US-Standard-A" },
    { value: "es-US-Standard-B", label: "es-US-Standard-B" },
    { value: "es-US-Standard-C", label: "es-US-Standard-C" },
    { value: "es-US-Wavenet-A", label: "es-US-Wavenet-A" },
    { value: "es-US-Wavenet-B", label: "es-US-Wavenet-B" },
    { value: "es-US-Wavenet-C", label: "es-US-Wavenet-C" },
    { value: "sv-SE-Standard-A", label: "sv-SE-Standard-A" },
    { value: "sv-SE-Standard-B", label: "sv-SE-Standard-B" },
    { value: "sv-SE-Standard-C", label: "sv-SE-Standard-C" },
    { value: "sv-SE-Standard-D", label: "sv-SE-Standard-D" },
    { value: "sv-SE-Standard-E", label: "sv-SE-Standard-E" },
    { value: "sv-SE-Wavenet-A", label: "sv-SE-Wavenet-A" },
    { value: "sv-SE-Wavenet-B", label: "sv-SE-Wavenet-B" },
    { value: "sv-SE-Wavenet-C", label: "sv-SE-Wavenet-C" },
    { value: "sv-SE-Wavenet-D", label: "sv-SE-Wavenet-D" },
    { value: "sv-SE-Wavenet-E", label: "sv-SE-Wavenet-E" },
    { value: "ta-IN-Standard-A", label: "ta-IN-Standard-A" },
    { value: "ta-IN-Standard-B", label: "ta-IN-Standard-B" },
    { value: "ta-IN-Wavenet-A", label: "ta-IN-Wavenet-A" },
    { value: "ta-IN-Wavenet-B", label: "ta-IN-Wavenet-B" },
    { value: "te-IN-Standard-A", label: "te-IN-Standard-A" },
    { value: "te-IN-Standard-B", label: "te-IN-Standard-B" },
    { value: "th-TH-Standard-A", label: "th-TH-Standard-A" },
    { value: "tr-TR-Standard-A", label: "tr-TR-Standard-A" },
    { value: "tr-TR-Standard-B", label: "tr-TR-Standard-B" },
    { value: "tr-TR-Standard-C", label: "tr-TR-Standard-C" },
    { value: "tr-TR-Standard-D", label: "tr-TR-Standard-D" },
    { value: "tr-TR-Standard-E", label: "tr-TR-Standard-E" },
    { value: "tr-TR-Wavenet-A", label: "tr-TR-Wavenet-A" },
    { value: "tr-TR-Wavenet-B", label: "tr-TR-Wavenet-B" },
    { value: "tr-TR-Wavenet-C", label: "tr-TR-Wavenet-C" },
    { value: "tr-TR-Wavenet-D", label: "tr-TR-Wavenet-D" },
    { value: "tr-TR-Wavenet-E", label: "tr-TR-Wavenet-E" },
    { value: "uk-UA-Standard-A", label: "uk-UA-Standard-A" },
    { value: "uk-UA-Wavenet-A", label: "uk-UA-Wavenet-A" },
    { value: "vi-VN-Standard-A", label: "vi-VN-Standard-A" },
    { value: "vi-VN-Standard-B", label: "vi-VN-Standard-B" },
    { value: "vi-VN-Standard-C", label: "vi-VN-Standard-C" },
    { value: "vi-VN-Standard-D", label: "vi-VN-Standard-D" },
    { value: "vi-VN-Wavenet-A", label: "vi-VN-Wavenet-A" },
    { value: "vi-VN-Wavenet-B", label: "vi-VN-Wavenet-B" },
    { value: "vi-VN-Wavenet-C", label: "vi-VN-Wavenet-C" },
    { value: "vi-VN-Wavenet-D", label: "vi-VN-Wavenet-D" }
];
